import React from 'react';
import { Button, makeStyles, TableRow, TextField, Theme } from '@material-ui/core';

import BodyCell from 'components/BodyCell';
import clsx from 'clsx';
import LoadingButtonIndicator from 'components/LoadingButtonIndicator';

interface Props {
  notes: string;

  setNotes: React.Dispatch<React.SetStateAction<string>>;

  notesError: string;
  setNotesError: React.Dispatch<React.SetStateAction<string>>;

  isSubmitting: boolean;
  onSubmit: React.FormEventHandler;
  onCancel: React.MouseEventHandler;

  primaryButtonLabel: string;
  customBackground?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  jobNoteTemplateForm: {
    height: 64
  },
  textFieldRoot: (props: Props) => ({
    backgroundColor: props.customBackground
  }),
  textFieldFont: {
    fontSize: '13px',
    height: 18
  },
  buttonContainer: {
    display: 'flex'
  },
  cancelButton: {
    marginRight: theme.spacing(2),
    width: 100
  },
  addButton: {
    width: 100
  }
}));

const CreateEditJobNoteTemplateForm: React.FC<Props> = props => {
  const classes = useStyles(props);

  const { notes, setNotes, notesError, setNotesError } = props;

  const { onSubmit, onCancel } = props;
  const { isSubmitting } = props;

  const { primaryButtonLabel, customBackground } = props;

  const handleBlur = (value: string) => {
    let ret = true;

    if (!notes || !notes.trim()) {
      setNotesError('Please enter notes name');
      ret = false;
    } else {
      setNotesError('');
      ret = true;
    }

    return ret;
  };

  return (
    <TableRow className={classes.jobNoteTemplateForm}>
      <BodyCell cellWidth='80%' isComponent={true}>
        <TextField
          margin='dense'
          required
          fullWidth
          className={clsx({ [classes.textFieldRoot]: customBackground })}
          id='name'
          label='Notes'
          error={notesError !== ''}
          helperText={notesError}
          value={notes}
          onChange={event => setNotes(event.target.value)}
          onBlur={event => handleBlur(event.target.value)}
          variant='outlined'
          autoComplete='off'
          InputProps={{
            classes: {
              input: classes.textFieldFont
            }
          }}
          InputLabelProps={{
            className: classes.textFieldFont
          }}
          multiline
          rows={4}
          rowsMax='4'
        />
      </BodyCell>
      <BodyCell cellWidth='20%' isComponent={true}>
        <div className={classes.buttonContainer}>
          <Button variant='contained' disableElevation className={classes.cancelButton} onClick={onCancel} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button onClick={onSubmit} variant='contained' disableElevation color='primary' className={classes.addButton} disabled={isSubmitting}>
            {primaryButtonLabel}
            <LoadingButtonIndicator isLoading={isSubmitting} />
          </Button>
        </div>
      </BodyCell>
    </TableRow>
  );
};

export default CreateEditJobNoteTemplateForm;
